import ButtonHOC from 'platform/react/hoc/button'
import Section from 'ui/Element/Section'

const SectionAsButton = ButtonHOC(Section)

export default SectionAsButton
